export default __webpack_public_path__ + "static/iterm-2-0df00389ca002a9a19e8073c9e5c6906.png";